import { Link } from "react-router-dom";
import Icon from "../components/Icon";
import { CLEANING_HIGHLIGHTS, CLEANING_STEPS } from "../content/site";
import useDocumentTitle from "../lib/useDocumentTitle";
import s from "./Cleaning.module.css";

export default function Cleaning() {
  useDocumentTitle("Čištění a detailing");

  return (
    <>
      <section className={s.hero}>
        <div className={`container ${s.heroGrid}`}>
          <div>
            <p className="eyebrow">Součást každého dovozu</p>
            <h1 className="h1" style={{ marginTop: 14 }}>Čištění a detailing každého vozu</h1>
            <p className="lead" style={{ marginTop: 16 }}>
              Každé auto projde důkladnou očistou zvenku i zevnitř. Profesionální parní čištění zničí 99 % bakterií
              a interiér vypadá jako nový — bez agresivní chemie.
            </p>
            <div className={s.ctas}>
              <Link to="/kontakt" className="btn btn-primary btn-lg">Nezávazně se zeptat <Icon name="arrow-right" size={18} /></Link>
              <Link to="/nabidka" className="btn btn-ghost btn-lg">Skladové vozy</Link>
            </div>
          </div>
          <figure className={s.video}>
            <video controls playsInline preload="none" poster="/cleaning-poster.jpg">
              <source src="/cleaning-video.mp4" type="video/mp4" />
              Váš prohlížeč nepodporuje přehrávání videa.
            </video>
            <figcaption>Ukázka parního čištění interiéru — sedadla, koberce, palubní deska.</figcaption>
          </figure>
        </div>
      </section>

      <section className="section" aria-labelledby="clean-steps">
        <div className="container">
          <p className="eyebrow">Postup</p>
          <h2 id="clean-steps" className="h2" style={{ margin: "12px 0 32px" }}>Krok za krokem</h2>
          <ol className={s.steps}>
            {CLEANING_STEPS.map((st, i) => (
              <li key={st.title}>
                <span className={s.num}>{String(i + 1).padStart(2, "0")}</span>
                <h3>{st.title}</h3>
                <p>{st.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="section">
        <div className={`container ${s.highlights}`}>
          {CLEANING_HIGHLIGHTS.map((h) => (
            <div key={h.title} className={s.highlight}>
              <Icon name={h.icon} size={24} />
              <h3>{h.title}</h3>
              <p>{h.text}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
